export const CLIENT_SECRET_FOR_0_AMOUNT_PAYMENT = 'n/a' // this mean that we don't have client secret, happen when process 0 amount payment
